import type { SpeakersDetails } from "@teksta/shared-types";
import { z } from "zod";

export const speakerFieldSchema = z.object({ name: z.string() });
export type SpeakerField = z.infer<typeof speakerFieldSchema>;

export function toSpeakersDetails(speakers: SpeakerField[]): SpeakersDetails {
  return Object.fromEntries(
    speakers
      .filter(({ name }) => name.trim())
      .map(({ name }, index) => [`SPEAKER_${index.toString().padStart(2, "0")}`, { label: name }])
  );
}

export function fromSpeakersDetails(value: unknown): SpeakerField[] {
  if (value == null) return [{ name: "" }];
  const details = z.record(z.string(), z.object({ label: z.string() })).parse(value);
  return Object.values(details).map(({ label }) => ({ name: label }));
}
